import { Skademeldingstype } from '../../types/generated-types';
import { assertUnreachable } from '../../utils/compiler-utils';

export const skadetypeFrom = (skadetype: string): Skademeldingstype => {
    const skademeldingstype = Object.keys(Skademeldingstype).find(
        (key) => key.toLowerCase() === skadetype.toLowerCase(),
    );
    return skademeldingstype ? (skademeldingstype as Skademeldingstype) : Skademeldingstype.Annet;
};

export const skadetypeToString = (skadetype: Skademeldingstype): string =>
    Object.values(Skademeldingstype).includes(skadetype) ? skadetype : Skademeldingstype.Annet;

export const getSkademeldingstypeFromQueryParam = (queryParameters: string): Skademeldingstype | null => {
    const urlParams = new URLSearchParams(queryParameters);
    const skadetype = urlParams.get('skadetype');
    return skadetype ? skadetypeFrom(skadetype as string) : null;
};

export const getSkadetypeNavn = (skadetype: Skademeldingstype): string => {
    switch (skadetype) {
        case Skademeldingstype.InnboEiendelerTvElektriskeArtikler:
            return 'Skade på TV eller andre elektriske produkter ';
        case Skademeldingstype.InnboEiendelerSkadePaAndreEiendeler:
            return 'Skade på andre eiendeler';
        case Skademeldingstype.InnboEiendelerSykkeltyveri:
            return 'Sykkeltyveri';
        case Skademeldingstype.InnboEiendelerTyveri:
            return 'Tyveri andre eiendeler';
        case Skademeldingstype.KollisjonMedAnnetKjoretoy:
            return 'Kollisjon med annet kjøretøy';
        case Skademeldingstype.SmaElektriskeKjoretoy:
            return 'Skade med elsparkesykkel';
        case Skademeldingstype.VarrelaterteSkader:
            return 'Værrelaterte skader';
        case Skademeldingstype.Feilfylling:
            return 'Feilfylling av drivstoff';
        case Skademeldingstype.BrannskadePaKjoretoy:
            return 'Brannskader på kjøretøy';
        case Skademeldingstype.MistetNokkel:
            return 'Mistet/ødelagt nøkkel';
        case Skademeldingstype.TyveriAvNokkel:
            return 'Tyveri av nøkkel';
        case Skademeldingstype.Glasskade:
            return 'Glasskade';
        case Skademeldingstype.Veihjelp:
            return 'Veihjelp';
        case Skademeldingstype.KjoretoyTyveriInnbrudd:
            return 'Innbrudd i kjøretøyet';
        case Skademeldingstype.KjoretoyTyveriStjaletOgFunnet:
            return 'Kjøretøyet var stjålet og er funnet';
        case Skademeldingstype.KjoretoyTyveriStjaletOgIkkeFunnet:
            return 'Kjøretøyet er stjålet og er ikke funnet';
        case Skademeldingstype.MotorOgAndreMaskinSkader:
            return 'Motor og andre maskinskader';
        case Skademeldingstype.TakrasPaParkertKjoretoy:
            return 'Takras på parkert kjøretøy';
        case Skademeldingstype.KollisjonBulkingEllerHarvarkPaParkertKjoretoy:
            return 'Kollisjon, bulking eller hærverk på parkerte kjøretøy';
        case Skademeldingstype.UtforkjoringEllerKollisjonMedAutovernEllerSkilt:
            return 'Utforkjøring eller kollisjon med autovern eller skilt';
        case Skademeldingstype.UtforkjoringEllerKollisjonMedHusMurkant:
            return 'Kollisjonskade med hus/garasje/murkant eller andre gjenstander';
        case Skademeldingstype.KollisjonskadePaKjoretoySteinIsEllerAnnetObjekt:
            return 'Kjørte over en gjenstand som skadet kjøretøyet';
        case Skademeldingstype.KollisjonskadePaKjoretoyDyr:
            return 'Kollisjon med et dyr';
        case Skademeldingstype.KollisjonskadePaKjoretoyMykTrafikant:
            return 'Kollisjon med en syklist eller fotgjenger';
        case Skademeldingstype.BatHarKollidertMedAnnenBat:
            return 'Kollisjon med en annen båt';
        case Skademeldingstype.BatHarKollidertMedBryggeEllerFastland:
            return 'Kollisjon med brygge eller fastland';
        case Skademeldingstype.BatHarTruffetFlytendeGjenstand:
            return 'Kjørte over en flytende gjenstand som skadet båten';
        case Skademeldingstype.BatGrunnstottEllerSkjar:
            return 'Kollisjon med holme eller skjær';
        case Skademeldingstype.BatHarSlittSegFraFortoyning:
            return 'Slitt seg fra fortøyning';
        case Skademeldingstype.BatHarSunket:
            return 'Sunket eller delvis sunket';
        case Skademeldingstype.BatInnbrudd:
            return 'Innbrudd i båten';
        case Skademeldingstype.BatStjaletOgFunnet:
            return 'Båten var stjålet og er funnet';
        case Skademeldingstype.BatStjaletOgIkkeFunnet:
            return 'Båten er stjålet og er ikke funnet';
        case Skademeldingstype.BatMaskinskader:
            return 'Maskinskader på båt';
        case Skademeldingstype.ReiseSykdomSkadeEllerUlykkePaReisen:
            return 'Sykdom eller skade på reisen';
        case Skademeldingstype.ReiseDodsfallEllerAlvorligSykdomPaReisen:
            return 'Dødsfall eller alvorlig sykdom';
        case Skademeldingstype.SkadetReisegods:
            return 'Skadet Reisegods';
        case Skademeldingstype.Reiseavbestilling:
            return 'Avbestilling eller ombooking før reisens start';
        case Skademeldingstype.ForsinketBagasje:
            return 'Forsinket bagasje';
        case Skademeldingstype.ForsinketTransport:
            return 'Forsinket transport';
        case Skademeldingstype.ReisegodsTyveri:
            return 'Tapt eller ødelagt reisegods';
        case Skademeldingstype.MistetReisegods:
            return 'Mistet reisegods';
        case Skademeldingstype.GjenglemtReisegods:
            return 'Gjenglemt reisegods';
        case Skademeldingstype.BygningNaturskadeStorm:
            return 'Storm';
        case Skademeldingstype.BygningNaturskadeFlom:
            return 'Flom';
        case Skademeldingstype.BygningNaturskadeSkred:
            return 'Skred';
        case Skademeldingstype.BygningNaturskadeAnnen:
            return 'Annen naturskade';
        case Skademeldingstype.BygningGlasskadeVinduDor:
            return 'Glasskade';
        case Skademeldingstype.BygningGlasskadeSanitarporselenDusjvegg:
            return 'Sanitærporselen eller dusjvegg';
        case Skademeldingstype.BygningGlasskadeIPlatetoppKomfyr:
            return 'Glass i platetopp eller komfyr';
        case Skademeldingstype.BygningGlasskadeAnnen:
            return 'Annen glasskade';
        case Skademeldingstype.BygningElektriskSkade:
            return 'Elektriske skader';
        case Skademeldingstype.BygningBrannskadeEllerSot:
            return 'Brannskader og sot';
        case Skademeldingstype.BygningBrannskadeAnnen:
            return 'Annen brannskade';
        case Skademeldingstype.BygningInnbrudd:
            return 'Innbrudd';
        case Skademeldingstype.BygningHarverk:
            return 'Hærverk';
        case Skademeldingstype.BygningVannskadeLekkasjeInne:
            return 'Lekkasje fra rør innendørs';
        case Skademeldingstype.BygningVannskadeLekkasjeUtvendigRor:
            return 'Lekkasje fra rør på tomten min';
        case Skademeldingstype.BygningVannskadeTilbakeslag:
            return 'Tilbakeslag';
        case Skademeldingstype.BygningVannskadeHustakYttervegg:
            return 'Vannskade fra hustak eller yttervegg';
        case Skademeldingstype.BygningVannskadeKjeller:
            return 'Vannskader i kjeller';
        case Skademeldingstype.BygningVannskadeAnnet:
            return 'Annen vannskade';
        case Skademeldingstype.BygningAnnet:
            return 'Annen bygningsskade';
        case Skademeldingstype.InnboEiendelerMatvarerFryserKjoleskap:
            return 'Ødelagte matvarer i fryser eller kjøleskap';
        case Skademeldingstype.InnboEiendelerMobilNettbrettPc:
            return 'Skade på mobil, nettbrett eller PC';
        case Skademeldingstype.Hund:
            return 'Hund';
        case Skademeldingstype.Katt:
            return 'Katt';
        case Skademeldingstype.Hest:
            return 'Hest';
        case Skademeldingstype.Dyr:
            return 'Dyr';
        case Skademeldingstype.Naring:
            return 'Næring';
        case Skademeldingstype.NaringTyveriUnderslag:
            return 'Tyveri eller underslag';
        case Skademeldingstype.NaringBygningsglass:
            return 'Bygningsglass';
        case Skademeldingstype.Landbruk:
            return 'Landbruk';
        case Skademeldingstype.LandbrukDriftsbygninger:
            return 'Driftsbygninger';
        case Skademeldingstype.LandbrukProduksjonsdyr:
            return 'Produksjonsdyr';
        case Skademeldingstype.LandbrukProduksjonsdyrStorfe:
            return 'Storfe';
        case Skademeldingstype.LandbrukProduksjonsdyrIndividuellOkse:
            return 'Avlsokse';
        case Skademeldingstype.LandbrukAvling:
            return 'Avling';
        case Skademeldingstype.LandbrukLosore:
            return 'Løsøre';
        case Skademeldingstype.LandbrukBrannvarslingsanlegg:
            return 'Brannvarslingsanlegg';
        case Skademeldingstype.LandbrukMelkerobot:
            return 'Melkerobot';
        case Skademeldingstype.Ansvar:
            return 'Ansvar';
        case Skademeldingstype.AnsvarPrivatPersonskade:
            return 'Ansvar personskade';
        case Skademeldingstype.AnsvarPrivatTingskade:
        case Skademeldingstype.AnsvarLandbrukNaringTingskade:
            return 'Ansvar tingskade';
        case Skademeldingstype.AnsvarLandbrukNaringFormueskade:
            return 'Ansvar formueskade';
        case Skademeldingstype.PersonskadeUlykke:
            return 'Personskade Ulykke';
        case Skademeldingstype.PersonskadeArbeidsuforhet:
            return 'Personskade Arbeidsuførhet';
        case Skademeldingstype.PersonskadeDodsfall:
            return 'Personskade Dødsfall';
        case Skademeldingstype.PersonskadeBarneOgUngdomsforsikring:
            return 'Barne- og ungdomsforsikring';
        case Skademeldingstype.PersonskadeKritiskSykdom:
            return 'Personskade Kritisk Sykdom';
        case Skademeldingstype.PersonskadeAnnet:
            return 'Personskade Annet';
        case Skademeldingstype.Rettshjelp:
            return 'Rettshjelp';
        case Skademeldingstype.RettshjelpTvistKjoretoy:
            return 'Tvist knyttet til kjøretøy';
        case Skademeldingstype.RettshjelpTvistBolig:
            return 'Tvist knyttet til kjøp/salg av leilighet, bolig eller fritidseiendom';
        case Skademeldingstype.RettshjelpTvistEntreprenorEllerHandverker:
            return 'Tvist mot entreprenør eller håndverker ';
        case Skademeldingstype.RettshjelpTvistNabo:
            return 'Tvist mot nabo';
        case Skademeldingstype.RettshjelpTvistJordskifteEllerFesterett:
            return 'Tvist om jordskifte- eller festerett';
        case Skademeldingstype.RettshjelpTvistOffentligForvaltningsvedtak:
            return 'Tvist om offentlig forvaltningsvedtak';
        case Skademeldingstype.RettshjelpTvistAnnenType:
            return 'Annen type tvist';
        case Skademeldingstype.Annet:
            return 'Annet';
        default:
            return assertUnreachable(skadetype);
    }
};

export const skademeldingstyperForPersonskade = () => {
    return [
        Skademeldingstype.PersonskadeAnnet,
        Skademeldingstype.PersonskadeArbeidsuforhet,
        Skademeldingstype.PersonskadeBarneOgUngdomsforsikring,
        Skademeldingstype.PersonskadeDodsfall,
        Skademeldingstype.PersonskadeUlykke,
        Skademeldingstype.PersonskadeKritiskSykdom,
    ];
};
